// Access key for the Control Center API, same model as the Call Health
// portal: entered once, kept in localStorage, sent as `x-cc-key` on every API
// request. installAccessKeyFetch() patches window.fetch once at startup, so
// the existing fetch() call sites need no changes.

const STORAGE_KEY = "cc-access-key";
export const API_BASE =
	process.env.REACT_APP_BASE_URL || "http://localhost:5001/api";

export const getAccessKey = () => {
	try {
		return localStorage.getItem(STORAGE_KEY);
	} catch {
		return null;
	}
};

export const setAccessKey = (key) => {
	try {
		localStorage.setItem(STORAGE_KEY, key);
	} catch {
		// Private mode / blocked storage: the key then lasts only for this page.
	}
};

export const clearAccessKey = () => {
	try {
		localStorage.removeItem(STORAGE_KEY);
	} catch {
		// ignore
	}
};

// Signs out: forget the key and return to the key prompt.
export const lockControlCenter = () => {
	clearAccessKey();
	window.location.reload();
};

const urlOf = (input) =>
	typeof input === "string"
		? input
		: input instanceof URL
			? input.href
			: input?.url || "";

// Only our own API gets the key; never send it to any other host.
const isApiRequest = (input) => urlOf(input).startsWith(API_BASE);

// Checks a key against the server before it is stored.
export const verifyAccessKey = async (key) => {
	const res = await window.fetch(`${API_BASE}/auth/check`, {
		headers: { "x-cc-key": key },
	});
	return res.ok;
};

let installed = false;
export const installAccessKeyFetch = () => {
	if (installed) return;
	installed = true;
	const originalFetch = window.fetch.bind(window);

	window.fetch = async (input, init = {}) => {
		if (!isApiRequest(input)) return originalFetch(input, init);

		const headers = new Headers(
			init.headers || (input instanceof Request ? input.headers : undefined),
		);
		// verifyAccessKey sets its own header; everything else uses the stored key.
		if (!headers.has("x-cc-key")) {
			const key = getAccessKey();
			if (key) headers.set("x-cc-key", key);
		}

		const res = await originalFetch(input, { ...init, headers });

		// The stored key was revoked or rotated: drop it and show the prompt.
		if (res.status === 401 && getAccessKey() && !urlOf(input).endsWith("/auth/check")) {
			lockControlCenter();
		}
		return res;
	};
};
